{
  "cookies": {
    "title": "Cookies",
    "manage": "Manage cookies",
    "body": "With your consent, we use cookies {{purposes}}. Refusing changes nothing else in the portal, and you can change your mind at any time from “$t(cookies.manage)” at the bottom of every page. <privacy>Privacy policy</privacy>",
    "short": {
      "measurement": "to measure the portal's audience and sign-ups (Google Analytics)",
      "advertising": "for our ads on LinkedIn and Google"
    },
    "and": " and ",
    "customize": "Customize my choices",
    "purposes": {
      "measurement": {
        "title": "Audience measurement",
        "text": "Google Analytics counts visits, the pages read and the accounts created."
      },
      "advertising": {
        "title": "LinkedIn and Google advertising",
        "text": "LinkedIn and Google measure the results of our ads and show them on their platforms to the portal's visitors."
      }
    },
    "save": "Save my choices",
    "accept": "Accept all",
    "refuse": "Refuse all"
  },
  "app": {
    "title": "Sculpt account",
    "byline": "by Peerception",
    "loading": "Loading…",
    "language": "Language",
    "signOut": "Sign out",
    "back": "Back",
    "backToSite": "Back to sculpt-agent.ai",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Saved.",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "close": "Close",
    "yes": "Yes",
    "no": "No",
    "error": "Something went wrong. Please try again.",
    "rateLimited": "Too many attempts. Please wait a moment and try again.",
    "rateLimitedTitle": "Too many attempts",
    "notFound": "This page does not exist.",
    "goHome": "Go to my account",
    "about": "About: {{label}}"
  },
  "nav": {
    "account": "Account",
    "organization": "Organization",
    "usage": "Usage",
    "invoices": "Invoices",
    "billing": "Billing"
  },
  "banner": {
    "unverified": "Confirm your email address to enable the assistant in Excel. We sent a link to {{email}}.",
    "resend": "Resend the email",
    "resent": "Email sent. Check your inbox (and the spam folder).",
    "suspended": "Your organization is suspended. Contact Peerception to restore access.",
    "archived": "Your organization is archived. Contact Peerception.",
    "goBilling": "Go to billing"
  },
  "auth": {
    "email": "Email",
    "emailPlaceholder": "you@company.com",
    "password": "Password",
    "passwordPlaceholder": "At least 8 characters",
    "passwordRule": "At least 8 characters.",
    "confirmPassword": "Confirm password",
    "show": "show",
    "hide": "hide",
    "firstName": "First name",
    "lastName": "Last name",
    "microsoft": "Continue with Microsoft",
    "or": "or",
    "signIn": "Sign in",
    "signingIn": "Signing in…",
    "createAccount": "Create an account",
    "creating": "Creating your account…",
    "haveAccount": "Already have an account?",
    "noAccount": "New to Sculpt?",
    "forgot": "Forgot password?",
    "invalidCredentials": "Invalid email or password.",
    "accountDisabled": "This account is disabled. Contact Peerception.",
    "passwordsDiffer": "The two passwords differ.",
    "weakPassword": "The password must be at least 8 characters.",
    "emailPlusAddress": "Use your address without the “+…” part: an account opens on the mailbox itself.",
    "emailDisposableDomain": "Disposable or temporary email addresses cannot open an account. Use your own address.",
    "emailTaken": "An account with this email already exists. Sign in instead.",
    "badInvitation": "This invitation is no longer valid.",
    "invitationMismatch": "This invitation was sent to another address.",
    "sso": {
      "sso_failed": "Microsoft sign-in failed. Please try again.",
      "cancelled": "Sign-in cancelled.",
      "account_disabled": "This account is disabled. Contact Peerception.",
      "staff_only": "This sign-in is reserved for Peerception staff.",
      "email_plus_address": "Use your address without the “+…” part: an account opens on the mailbox itself.",
      "email_disposable_domain": "Disposable or temporary email addresses cannot open an account. Use your own address.",
      "link_mismatch": "This Microsoft account does not use your Sculpt account's address: nothing was linked. Sign in to Microsoft with that address and try again."
    }
  },
  "signup": {
    "title": "Create your Sculpt account",
    "subtitle": "The financial-modelling assistant in Excel. Free to start.",
    "invited": "You are joining {{organization}}",
    "invitedHint": "The invitation was sent to this address."
  },
  "legal": {
    "mention": "By continuing, you accept the <terms>Terms of sale</terms>, including the <dpa>Data Processing Agreement</dpa>. See our <privacy>Privacy policy</privacy>.",
    "accept": "I accept the <terms>Terms of sale</terms>, including the <dpa>Data Processing Agreement</dpa>."
  },
  "login": {
    "title": "Sign in",
    "subtitle": "Use your Sculpt account.",
    "rateLimited": "Too many sign-in attempts. Wait 15 minutes, or sign in with Microsoft."
  },
  "discovery": {
    "title": "How did you hear about us?",
    "subtitle": "This question is optional. Your answer helps us know where to make Sculpt known.",
    "continue": "Continue",
    "skip": "Skip",
    "sources": {
      "linkedin": "LinkedIn",
      "google": "Google",
      "youtube": "YouTube",
      "word_of_mouth": "Word of mouth",
      "other": "Other"
    }
  },
  "verify": {
    "title": "Confirming your email…",
    "success": "Your email is confirmed.",
    "successHint": "Open Excel, install the Sculpt add-in and sign in with this account. Your organization: {{organization}}.",
    "openAccount": "Open my account",
    "failed": "This link is invalid or has expired.",
    "failedHint": "Verification links last 24 hours. Sign in and ask for a new one.",
    "resend": "Send a new link",
    "signIn": "Sign in"
  },
  "forgot": {
    "title": "Reset your password",
    "subtitle": "Tell us your email; if an account exists, a link is on its way.",
    "send": "Send the link",
    "sending": "Sending…",
    "done": "If an account exists for {{email}}, a reset link is on its way. It lasts one hour.",
    "backToLogin": "Back to sign in"
  },
  "reset": {
    "title": "Choose a new password",
    "subtitle": "This signs you out everywhere else.",
    "submit": "Set the password",
    "submitting": "Saving…",
    "done": "Your password is set. You have been signed out everywhere; sign in with the new one.",
    "failed": "This link is invalid or has expired. Ask for a new one.",
    "again": "Ask for a new link"
  },
  "invite": {
    "title": "You are invited",
    "lead": "{{inviter}} invites you to join {{organization}} on Sculpt as {{role}}.",
    "leadNoInviter": "You are invited to join {{organization}} on Sculpt as {{role}}.",
    "sentTo": "Sent to {{email}}.",
    "createAccount": "Create an account",
    "signInToAccept": "Sign in to accept",
    "accept": "Join {{organization}}",
    "accepting": "Joining…",
    "accepted": "You are now a member of {{organization}}.",
    "mismatch": "You are signed in as {{current}}, but this invitation was sent to {{email}}. Sign out and use that address.",
    "invalid": "This invitation is no longer valid.",
    "invalidHint": "It may have been accepted, revoked, or it expired after 14 days. Ask the organization's admin for a new one.",
    "ownerMustTransfer": "You own an organization with other members: transfer its ownership before joining another one.",
    "alreadyMember": "You are already a member of this organization."
  },
  "callback": {
    "title": "Signing you in…",
    "failed": "Sign-in did not complete.",
    "retry": "Back to sign in",
    "backToAccount": "Back to my account"
  },
  "role": {
    "owner": "Owner",
    "admin": "Admin",
    "member": "Member"
  },
  "account": {
    "title": "Your account",
    "profile": "Profile",
    "locale": "Language of emails",
    "password": "Password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "changePassword": "Change the password",
    "passwordChanged": "Password changed.",
    "wrongPassword": "The current password is wrong.",
    "setPassword": "This account signs in with Microsoft and has no password.",
    "setPasswordLink": "Set a password by email",
    "microsoft": "Microsoft sign-in",
    "microsoftLinked": "Linked to {{email}}",
    "microsoftTenant": "Tenant {{tenant}}",
    "microsoftNotLinked": "Not linked. Link the Microsoft account that uses {{email}} to sign in with one click from Excel.",
    "linkMicrosoft": "Link Microsoft",
    "excel": {
      "title": "Get started in Excel",
      "step1": "Install the Sculpt add-in in Excel Desktop (Windows or Mac).",
      "step2": "Open the Sculpt pane and sign in with this account.",
      "step3": "Ask the assistant about the open workbook.",
      "link": "Installation guide"
    },
    "review": {
      "title": "Review of your conversations",
      "intro": "To check Sculpt's quality, we review some conversations picked at random. You can object to it by writing to",
      "objected": "Your objection is recorded since {{date}}: your conversations are no longer picked.",
      "organization": "Your organization keeps its conversations out of this review since {{date}}.",
      "guardrail": "Conversations where Sculpt failed, or that you report or rate negatively, are still reviewed to fix incidents."
    }
  },
  "org": {
    "title": "Organization",
    "personalHint": "This is your personal organization. Invite a colleague or claim your company domain to turn it into a team.",
    "name": "Name",
    "plan": "Plan",
    "billingEmail": "Billing email",
    "readOnly": "Only admins can change these details.",
    "members": "Members",
    "member": "member",
    "membersCount": "{{count}} member",
    "membersCount_other": "{{count}} members",
    "joined": "Joined",
    "unverified": "unverified",
    "inactive": "inactive",
    "you": "you",
    "makeAdmin": "Make admin",
    "makeMember": "Make member",
    "remove": "Remove",
    "removeConfirm": "Remove {{email}} from the organization? They keep their account in a personal organization.",
    "transfer": "Transfer ownership",
    "transferConfirm": "Make {{email}} the owner? You become an admin.",
    "invitations": "Invitations",
    "invitationsNone": "No pending invitation.",
    "invite": "Invite",
    "inviting": "Inviting…",
    "invited": "Invitation sent to {{email}}.",
    "inviteEmail": "Email to invite",
    "inviteRole": "Role",
    "expires": "Expires",
    "revoke": "Revoke",
    "alreadyMember": "This address is already a member.",
    "claims": "Domains and Microsoft tenants",
    "claimsHint": "People who sign up with a verified email on a claimed domain, or with a Microsoft work account of a claimed tenant, join this organization automatically.",
    "claimsRules": "Peerception verifies every claim before anyone joins through it; you will see it go from pending to verified. Public mailbox domains (gmail.com, outlook.com…) cannot be claimed.",
    "claimsNone": "No claim yet.",
    "claimKind": "Kind",
    "claimDomain": "Email domain",
    "claimTenant": "Microsoft tenant id",
    "claimValue": "Value",
    "claimDomainPlaceholder": "company.com",
    "claimTenantPlaceholder": "00000000-0000-0000-0000-000000000000",
    "claim": "Claim",
    "claiming": "Claiming…",
    "verified": "Verified",
    "pending": "Pending verification by Peerception",
    "autoJoin": "Auto-join",
    "claimTaken": "Another organization holds this claim.",
    "claimRefused": "This value cannot be claimed (a public mailbox domain, or not a valid domain / tenant id).",
    "leave": "Leave the organization",
    "leaveHint": "You get a fresh personal organization. Your conversations stay yours.",
    "leaveConfirm": "Leave {{organization}}?",
    "ownerMustTransfer": "You own this organization and it has other members: transfer the ownership first.",
    "left": "You left the organization.",
    "seeBilling": "See the subscription",
    "cap": "Limit per month",
    "capTrial": "Limit for the trial",
    "noCap": "No limit",
    "capDefault": "{{amount}} (default)",
    "capUseDefault": "Use the default ({{amount}})",
    "capUseDefaultNone": "Use the default (none set: no limit)",
    "capOwn": "Own limit",
    "capAmount": "Own limit in {{symbol}}",
    "capNone": "No limit",
    "capInvalid": "Enter an amount in {{currency}}, such as 50.",
    "defaultCap": "Default monthly limit per member",
    "defaultCapTrial": "Default limit per member for the trial",
    "defaultCapCurrent": "Current default: {{amount}} per month.",
    "defaultCapCurrentTrial": "Current default: {{amount}} for the trial.",
    "defaultCapNone": "No default yet: members without their own limit have no limit.",
    "defaultCapHint": "It applies to every member without their own limit. A member can have their own limit, or no limit, in the members table below.",
    "defaultCapLabel": "Limit per member ({{symbol}})",
    "defaultCapSuggested_one": "Suggested: {{amount}} (monthly credits {{pool}} ÷ {{count}} seat)",
    "defaultCapSuggested_other": "Suggested: {{amount}} (monthly credits {{pool}} ÷ {{count}} seats)",
    "defaultCapSuggestedTrial_one": "Suggested: {{amount}} (the trial's credits {{pool}} ÷ {{count}} seat)",
    "defaultCapSuggestedTrial_other": "Suggested: {{amount}} (the trial's credits {{pool}} ÷ {{count}} seats)",
    "defaultCapSuggestedPlain": "Suggested: {{amount}}",
    "defaultCapRemove": "Remove the default",
    "seatsFull": "Every seat is taken ({{seats}}, counting pending invitations). Add seats on the billing page first.",
    "seatsFullScheduled": "The offer change scheduled for the end of the period leaves fewer seats: you cannot invite beyond them. Undo it on the billing page to invite.",
    "seatsLine": "{{used}} of {{seats}} seats used",
    "addSeats": "add seats",
    "billingEmailHint": "Where we send orders and invoices. Empty: the owner's email."
  },
  "usage": {
    "title": "Usage",
    "allowance": "Allowance",
    "unlimited": "Unlimited",
    "spent": "{{spent}} of {{allowance}} used",
    "spentUnlimited": "{{spent}} used",
    "remaining": "{{remaining}} left",
    "periodTotal": "in total",
    "periodMonth": "this month",
    "since": "since {{date}}",
    "limitReached": "The allowance is spent: the assistant no longer answers until it is extended. Contact Peerception.",
    "requests": "{{count}} model call",
    "requests_other": "{{count}} model calls",
    "perMember": "Per member",
    "yourLine": "Your usage",
    "noUsage": "No usage in this period yet.",
    "hint": "Every model call is priced in {{currency}}; the monthly credits are your organization's, shared by its members, then pack credits take over.",
    "reason": {
      "no_subscription": "Your organization has no active subscription: the assistant is paused.",
      "trial_ended": "The trial has ended: the assistant is paused until an offer is chosen.",
      "payment_overdue": "A renewal is unpaid: the assistant is paused until it is paid.",
      "member_cap_reached": "You reached the limit your administrator set for you ({{cap}}).",
      "user_cap_reached": "You used your share of the monthly credits for this period ({{cap}}). A credit pack or a larger tier lifts it.",
      "limit_reached": "The monthly credits and the pack credits are spent: the assistant is paused until the next period, or until credits are added.",
      "free_full": "Every place on the Free offer is taken for now: choose an offer to use the assistant."
    },
    "goBilling": "Open billing",
    "yours": "Your usage",
    "capPerMonth": "per month",
    "capForTrial": "for the trial",
    "userCap": "Your share (per member)",
    "credits": "Credits left",
    "noPool": "No subscription: no monthly credits. The pack credits left are used.",
    "poolTitle": "Subscription monthly credits",
    "poolTitleOffer": "Subscription monthly credits · {{offer}}",
    "creditsTitle": "Pack credits",
    "creditsLeft": "{{credits}} available",
    "creditsHint": "Packs do not renew each month: they take over once the monthly credits are spent, the earliest to expire first.",
    "periodTrial": "trial",
    "until": "until {{date}}",
    "own": {
      "title": "Your usage",
      "bar": "Your limit used this period",
      "noLimit": "No limit set by your admin",
      "limitMonth": "Your limit: {{cap}} per month",
      "limitTrial": "Your limit: {{cap}} for the trial",
      "orgSpent": "Your organization's usage for this period is spent: the assistant is paused until the next period or until an admin adds credits.",
      "hint": "Every model call is priced in {{currency}}. Your organization's admins manage the subscription and the limits."
    }
  },
  "invoices": {
    "title": "Invoices",
    "none": "No invoice yet.",
    "number": "Number",
    "issued": "Issued",
    "due": "Due",
    "amount": "Excl. VAT",
    "status": "Status",
    "download": "Download PDF",
    "adminOnly": "Only admins of the organization can see its invoices.",
    "statusLabel": {
      "sent": "Due",
      "paid": "Paid",
      "void": "Void",
      "draft": "Draft"
    },
    "total": "Incl. VAT",
    "kind": {
      "invoice": "Invoice",
      "credit_note": "Credit note"
    },
    "creditsInvoice": "Cancels invoice {{number}}",
    "creditNote": "Credit note"
  },
  "handoff": {
    "notice": "You are signing in for the Sculpt add-in in Excel. This window closes by itself once you are done."
  },
  "pricing": {
    "currency": "Currency",
    "trialFor": "Free for {{days}} days",
    "perSeat": "{{price}} per user / month",
    "unlimitedUsage": "Unlimited credits",
    "trialUsage": "{{amount}} of credits for the trial",
    "usagePerSeat": "{{amount}} of credits per user / month",
    "userCap": "Up to {{amount}} per member / month",
    "seatsFrom": "From {{min}} user(s)",
    "seatsRange": "{{min}} to {{max}} users",
    "validFor": "valid {{count}} month",
    "validFor_other": "valid {{count}} months",
    "noExpiry": "never expires",
    "fromTier": "From {{price}} / month",
    "tierRange": "{{min}} to {{max}} of credits per month",
    "usagePerMonth": "{{amount}} of credits per month",
    "oneUser": "1 user",
    "anyUsers": "As many users as you need",
    "tierLabel": "Monthly credits",
    "tierUsage": "{{usage}} of credits",
    "lowUsage": "That is {{perUser}} of credits per user and per month: under {{min}}, members risk being blocked early in the month.",
    "features": {
      "free": [
        "No card needed",
        "Upgrade whenever you like"
      ],
      "solo": [
        "For one modeller",
        "Bonus credits on larger tiers",
        "Credit packs when you need more"
      ],
      "team": [
        "Credits shared by the team",
        "Per-member limits set by an admin",
        "Credits used per member",
        "Roles: owner, admin, member",
        "One invoice for the team"
      ]
    },
    "plusSharedCredits": "+ shared monthly credits from {{price}}",
    "plusCredits": "+ monthly credits from {{price}}",
    "tierRangeShared": "{{min}} to {{max}} of credits per month, shared by the whole team",
    "breakdown": {
      "seats": "Seats",
      "credits": "Monthly credits",
      "sharedCredits": "Shared credits",
      "usage": "({{usage}} of usage)",
      "usageTeam": "({{usage}} of usage for the whole team)",
      "total": "Total / month excl. VAT",
      "totalInclVat": "Total / month incl. VAT",
      "perUser": "≈ {{perUser}} of usage per user"
    }
  },
  "billing": {
    "title": "Subscription",
    "none": "No subscription",
    "noneHint": "Your organization has no subscription. Choose an offer below.",
    "adminsOnly": "Only the owner and the admins of the organization can change the subscription or buy credits.",
    "status": {
      "trialing": "trial",
      "active": "active",
      "past_due": "unpaid",
      "ended": "ended",
      "canceled": "canceled"
    },
    "reason": {
      "packs_only": "Your organization no longer has a subscription: the assistant uses the pack credits left, then pauses. Choose an offer to get monthly credits and buy packs again.",
      "no_subscription": "Your organization has no active subscription: the assistant is paused.",
      "trial_ended": "The trial has ended: choose an offer to turn the assistant back on.",
      "payment_overdue": "A renewal is unpaid: the assistant is paused until it is paid.",
      "free_full": "Every place on the Free offer is taken for now. Choose Solo or Team below to use the assistant."
    },
    "poolLabel": "Monthly credits this period",
    "poolUnlimited": "{{spent}} used · unlimited",
    "poolUsed": "{{spent}} of {{pool}}",
    "prorated": "Prorated: the offer changed on {{date}}, during the period, so the new tier's credits only count for the days left.",
    "proratedNext": "{{full}} a month from {{date}}.",
    "offer": "Offer",
    "version": "terms of version {{version}}",
    "price": "Price",
    "free": "Free",
    "priceTotal": "{{price}} × {{seats}} = {{total}} / month excl. VAT",
    "seats": "Users",
    "seatsUsed": "{{used}} of {{seats}} used (members and pending invitations)",
    "trialEnds": "Trial ends",
    "endsOn": "Ends on",
    "renewsOn": "Renews on",
    "userCap": "Cap per member / month",
    "credits": "Pack credits",
    "grandfathered": "You keep the terms you subscribed to; the offer's current terms are different and apply if you change offer.",
    "scheduled": "Scheduled on {{date}}: {{offer}} × {{seats}} at {{price}} per user.",
    "undo": "Undo",
    "canceling": "The subscription ends on {{date}}.",
    "keep": "Keep the subscription",
    "pendingTitle": "Order no. {{number}} awaits payment: {{amount}} excl. VAT",
    "pendingHint": "It takes effect as soon as the payment is received.",
    "pendingRenewal": "The renewal of the subscription; the assistant stays on during the grace days.",
    "withdraw": "Withdraw this order",
    "withdrawConfirm": "Withdraw this order? Nothing will change.",
    "chooseTitle": "Choose an offer",
    "changeTitle": "Change offer or users",
    "current": "current",
    "error": {
      "seats_below_members": "Fewer users than your members and pending invitations: remove some first.",
      "seats_out_of_range": "This offer does not allow that number of users.",
      "no_change": "That is already your subscription.",
      "trial_not_selectable": "The trial cannot be chosen again.",
      "offer_not_found": "This offer is no longer available.",
      "pack_not_found": "This pack is no longer available.",
      "renewal_is_owed": "A renewal cannot be withdrawn.",
      "free_not_selectable": "Free cannot be chosen.",
      "tier_required": "Choose your monthly credits.",
      "tier_not_offered": "This credit tier is not offered.",
      "packs_require_paid_offer": "Credit packs come on top of Solo or Team.",
      "currency_mismatch": "Your organization is now billed in another currency: reload the page to see its prices.",
      "currency_locked": "Your organization's currency is fixed by what it has already paid.",
      "currency_not_offered": "Prices are not offered in this currency."
    },
    "creditsTitle": "Pack credits",
    "creditsHint": "Pack credits are used once the period's monthly credits are spent, the ones expiring first first.",
    "grantPack": "Pack",
    "grantStaff": "Offered by Peerception",
    "expiresOn": "until {{date}}",
    "buy": "Buy",
    "ordersTitle": "Orders",
    "orderWhat": "What",
    "orderDate": "Date",
    "kind": {
      "subscribe": "Subscription",
      "change": "Change of offer",
      "seats": "Users",
      "renewal": "Renewal",
      "pack": "Credits"
    },
    "orderStatus": {
      "pending": "awaiting payment",
      "paid": "paid",
      "canceled": "withdrawn",
      "failed": "failed"
    },
    "invoicesHint": "Invoices are sent by email and listed in",
    "cancelTitle": "Cancel the subscription",
    "cancelHint": "The subscription runs until {{date}}, then the assistant is paused. You can undo it until then.",
    "cancel": "Cancel at the end of the period",
    "cancelConfirm": "Cancel the subscription on {{date}}?",
    "tier": "Monthly credits",
    "tierValue": "{{usage}} / month",
    "priceSum": "{{total}} / month excl. VAT = {{parts}}",
    "pricePartTier": "{{price}} subscription",
    "pricePartSeats": "{{price}} × {{count}} user",
    "pricePartSeats_other": "{{price}} × {{count}} users",
    "priceMonthly": "{{total}} / month excl. VAT",
    "scheduledTier": "Scheduled on {{date}}: {{offer}} × {{seats}} with the {{tier}} tier.",
    "packsNeedPaid": "Credit packs come on top of Solo or Team.",
    "amountExclVat": "Excl. VAT",
    "amountInclVat": "Incl. VAT",
    "vat": {
      "line": "VAT {{rate}}: {{amount}}",
      "reverseCharge": "Reverse charge: VAT due by the customer",
      "outsideScope": "VAT not applicable",
      "total": "Total incl. VAT: {{total}}",
      "held": "Your VAT number is being verified: this order can be paid once it is confirmed.",
      "heldShort": "being verified",
      "noProfile": "The VAT is set once the billing profile is complete.",
      "noProfileLink": "Complete the billing profile"
    },
    "card": {
      "pay": "Pay {{total}} by card",
      "redirecting": "Opening the payment page…",
      "saved": "Saved card",
      "savedValue": "{{label}}, expires {{expiry}}",
      "retry": "Try again",
      "return": {
        "checking": "Checking your payment…",
        "paid": "Payment received: your order is active.",
        "failed": "The payment was declined. Nothing was charged.",
        "canceled": "The payment was canceled. Nothing was charged.",
        "expired": "The payment page expired before the payment. Nothing was charged.",
        "waiting": "We are waiting for your bank's confirmation; you will receive an email as soon as it arrives."
      },
      "error": {
        "payments_disabled": "Card payment is not available yet.",
        "order_not_payable": "This order can no longer be paid.",
        "vat_review_pending": "Your VAT number is being verified: this order can be paid once it is confirmed.",
        "billing_profile_required": "Complete the billing profile to pay by card.",
        "nothing_to_pay": "There is nothing to pay for this order.",
        "payment_provider_unavailable": "Card payment is temporarily unavailable, try again in a few minutes.",
        "payment_in_progress": "A card payment is in progress for this order: it cannot be withdrawn now."
      },
      "renewalsAuto": "Your renewals are charged automatically on this card.",
      "none": "No saved card — your renewals will have to be paid from this page.",
      "register": "Save a card",
      "change": "Change card",
      "remove": "Remove the card",
      "removeConfirm": "Remove the saved card? Your renewals will then have to be paid by hand from this page.",
      "verificationHint": "Saving a card goes through a zero-amount verification on Mollie's page: nothing is charged.",
      "expiresBeforeRenewal": "This card expires before your next renewal: save a new one so it goes through without interruption.",
      "autoFailed": "The automatic payment of your renewal failed.",
      "update": {
        "checking": "Checking your card…",
        "paid": "New card saved: your next renewals will be charged on it.",
        "failed": "The card verification was declined. No card was saved.",
        "canceled": "The card verification was canceled. No card was saved.",
        "expired": "The verification page expired. No card was saved."
      }
    },
    "changeOffer": "Change offer",
    "chooseOffer": "Subscribe"
  },
  "profile": {
    "title": "Billing profile",
    "hint": "Sculpt is sold to professionals. These details appear on your invoices, and your country and VAT number set the VAT of your orders.",
    "complete": "complete",
    "incompleteBadge": "incomplete",
    "incomplete": "Your billing profile is incomplete: it is needed to set the VAT of your orders and to issue your invoices.",
    "kind": "You are",
    "kinds": {
      "company": "A company",
      "individual": "A sole trader"
    },
    "nameCompany": "Company name",
    "nameIndividual": "First and last name",
    "street": "Address",
    "zip": "Postcode",
    "city": "City",
    "country": "Country",
    "siren": "SIREN",
    "sirenHint": "9 digits. You can paste your SIRET: we keep the SIREN.",
    "vat": "EU VAT number",
    "vatHint": "Optional. Checked with VIES, the EU register of VAT numbers.",
    "vatValid": "VAT number {{number}} verified with VIES on {{date}}.",
    "vatInvalid": "VIES does not recognise the VAT number {{number}}: French VAT (20 %) applies to your orders until it is valid.",
    "vatReview": "VIES could not check the VAT number {{number}} for now. We are checking it.",
    "vatReviewHeld": "Until then, your orders wait before they can be paid.",
    "error": {
      "sirenRequired": "Enter the 9-digit SIREN of your business.",
      "invalid_country": "Choose a country from the list.",
      "invalid_customer_kind": "Choose company or sole trader.",
      "invalid_siren": "A SIREN has 9 digits.",
      "invalid_vat_number": "This does not look like a VAT number: it starts with the country code, e.g. DE123456789.",
      "vat_country_mismatch": "This VAT number is not from the billing country: an EU VAT number starts with the country's code.",
      "vat_number_required": "Enter your EU VAT number: it is required for a business in the EU outside France.",
      "vat_number_invalid": "VIES does not recognise this VAT number. Correct it to continue.",
      "vies_unavailable": "VIES is unavailable, try again in a few minutes.",
      "rate_limited": "Too many checks in a row. Try again in a minute."
    },
    "vatHintRequired": "Required for a business in the EU outside France. Checked with VIES.",
    "vatChecking": "Checking with VIES…",
    "vatRecognized": "Recognised by VIES: {{name}}",
    "vatRecognizedNoName": "Number recognised by VIES.",
    "vatRejected": "VIES does not recognise this number. Correct it to continue.",
    "vatUnavailableFr": "VIES is not answering right now: you can continue, we will check the number later.",
    "vatUnavailableEu": "VIES is unavailable, try again in a few minutes.",
    "vatRetry": "Try again",
    "vatRequired": "Enter your EU VAT number: it is required for a business in the EU outside France.",
    "vatCheckFailed": "The number could not be checked. Try again.",
    "sirenInfo": "The 9 digits that identify your business in France. You find them on your Kbis extract, your INSEE notice or at the start of your SIRET. They are required on electronic invoices.",
    "registration": "Registration number",
    "registrationHint": "Optional. Shown on your invoices if you give it.",
    "registrationInfo": "The number your business is registered under in its country: Handelsregister (HRB) in Germany, BCE number in Belgium, KvK in the Netherlands, Companies House in the UK… Type it as it should appear on your invoices."
  },
  "checkout": {
    "steps": "Checkout steps",
    "stepOffer": "Offer",
    "stepBilling": "Billing",
    "stepPayment": "Payment",
    "adminsOnly": "Only the organization's owner and admins can change the offer or buy credits. Ask one of them.",
    "tabOffer": "Offer",
    "tabCredits": "Credits",
    "yourOffer": "Your offer",
    "perUser": "{{price}} per user/month",
    "perMonth": "{{price}}/month",
    "bonus": "+{{bonus}}% credits",
    "fewerUsers": "One user fewer",
    "moreUsers": "One user more",
    "atLeast": "at least {{count}} (your members and invitations)",
    "noChange": "That is your current offer.",
    "continue": "Continue",
    "edit": "Edit",
    "profileWhy": "Your invoices are issued in this name. The VAT is set from it.",
    "vatReview": "Your VAT number is being verified. You can place the order now: you can pay it once the number is confirmed (we email you).",
    "profileMissing": "The billing profile is missing.",
    "paymentTitle": "Payment",
    "confirmTitle": "Confirmation",
    "scheduledHint": "The change applies on {{date}}. Nothing to pay today.",
    "freeHint": "Nothing to pay today.",
    "exclVat": "Excl. VAT",
    "inclVat": "Total incl. VAT",
    "vatLine": "VAT {{rate}}",
    "secure": "Secure payment by Mollie (3-D Secure). Your card is saved to pay your renewals automatically; you can change or remove it at any time.",
    "secureShort": "Secure payment",
    "leave": "Back to billing",
    "transferHint": "Your order is paid by bank transfer: the details come with the order.",
    "pay": "Pay {{total}} by card",
    "payPack": "Order and pay by card",
    "placeOrder": "Place the order",
    "confirmChange": "Confirm the change",
    "summary": "Summary",
    "currently": "Currently: {{offer}}, {{price}}/month",
    "today": "To pay today",
    "exclVatShort": "excl. VAT",
    "inclVatShort": "incl. VAT",
    "prorata": "prorated until {{date}}",
    "appliesOn": "applies on {{date}}, nothing to pay today",
    "then": "then {{price}}/month excl. VAT",
    "doneApplied": "Done: your new offer applies now.",
    "doneScheduled": "Done: the change applies on {{date}}.",
    "doneOrdered": "Order no. {{number}} placed: {{total}}.",
    "backToBilling": "Back to billing",
    "payOrder": "Pay this order",
    "thenInclVat": "then {{price}}/month incl. VAT",
    "vatLater": "VAT added at the next step",
    "billedTo": "Billed to",
    "vatNumber": "VAT",
    "tierLabelShared": "Shared credits for the team",
    "seatsOnTop": "One pool for the whole team. Seats are billed on top: {{price}} per user / month."
  },
  "plan": {
    "trial": "Trial",
    "renews": "Renews {{date}}",
    "trialEnds": "Trial ends {{date}}",
    "details": "Details",
    "upgrade": "Upgrade",
    "bar": "Allowance used this period",
    "credits": "+ {{credits}} of prepaid credits"
  },
  "link": {
    "failed": "This link has expired",
    "expired": "The link from Excel works once and for two minutes. Sign in to continue.",
    "signIn": "Sign in"
  },
  "models": {
    "title": "AI models",
    "intro": "Owners and admins choose which models the organization's members may use. A refused model is never called for the organization: not for conversations, workbook indexing or summaries.",
    "readOnly": "Only admins can change the allowed models.",
    "madeBy": "model by {{maker}}",
    "hostedBy": "hosted by {{host}}",
    "dataIn": "data processed in",
    "price1": "Low price",
    "price2": "High price",
    "lastAllowed": "At least one model must stay allowed.",
    "noModelLeft": "At least one model must stay allowed."
  },
  "reviewSample": {
    "title": "Quality review",
    "intro": "To check Sculpt's quality, we review some conversations picked at random. You can keep your organization out of it: we then review only the conversations where Sculpt failed, those your members report or rate negatively, and those that breach our terms.",
    "optOut": "Keep the organization out of the review of conversations picked at random",
    "since": "Out of it since {{date}}.",
    "ownerOnly": "Only the owner can change this.",
    "freeOffer": "Available on paid offers."
  },
  "flag": {
    "US": "United States",
    "FR": "France",
    "EU": "European Union"
  }
}
